/* eslint-disable no-nested-ternary */
import { useCallback, useState } from 'react';
import { KeyboardTypeOptions, StyleSheet } from 'react-native';
import { TextInput } from 'react-native-paper';
import TextButton from '../elements/TextButton';
import { Text, View } from '../Themed';
import Colors from '../../constants/Colors';

export type InfoInputParamList = {
  questionCategory: string;
  title: string[];
  onSubmit?: (response: string) => void;
  validationFunc?: (input: string) => string;
  keyboardType?: KeyboardTypeOptions | undefined;
  label?: string;
};

export default function SingleInputScreen(props: InfoInputParamList) {
  const { questionCategory, title, onSubmit } = props;
  const [value, setValue] = useState<string>();
  const [valid, setValid] = useState<boolean>(true);
  const [validationErrorMessage, setValidationErrorMessage] = useState<string>('');

  const onChangeValue = (newValue: string) => {
    if (newValue === '') {
      setValue(undefined);
    } else {
      setValue(newValue);
    }
  };

  const handleSubmit = useCallback(() => {
    const strValue = typeof value === 'string' ? value : '';
    const tempValidationErrorMessage = props.validationFunc ? props.validationFunc(strValue) : '';
    setValid(tempValidationErrorMessage === '');
    setValidationErrorMessage(tempValidationErrorMessage);
    if (typeof onSubmit === 'function' && tempValidationErrorMessage === '') {
      onSubmit(strValue);
    }
  }, [value, props, onSubmit]);

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{title}</Text>
      <TextInput
        keyboardType={props.keyboardType ?? 'numeric'}
        label={props.label}
        value={value === undefined ? '' : value}
        onChangeText={onChangeValue}
        style={[styles.input, { width: 300 }, { fontFamily: 'Quicksand' }]}
        underlineColor="#31373E"
        activeUnderlineColor={Colors.snapCalorie.buttonBlue}
        activeOutlineColor={Colors.snapCalorie.buttonBlue}
        autoComplete="off"
      />
      <TextButton
        textStyle={{
          fontSize: 20,
          fontWeight: '600',
          lineHeight: 25,
          letterSpacing: -0.29,
          color: '#F8F5F4',
        }}
        style={[
          styles.buttonWrapper,
          {
            backgroundColor: Colors.snapCalorie.buttonBlue,
          },
        ]}
        onPress={handleSubmit}
        text="Next"
      />
      {!valid && <Text style={[styles.invalidText, { color: 'red' }]}>{validationErrorMessage}</Text>}
    </View>
  );
}
SingleInputScreen.defaultProps = {
  onSubmit: () => {},
  validationFunc: () => '',
  label: '',
  keyboardType: undefined,
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignSelf: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 20,
    lineHeight: 24,
    maxWidth: 300,
    fontWeight: '500',
    letterSpacing: 0,
    color: '#14181B',
    marginBottom: 40,
  },
  heightInputWrap: {
    flexDirection: 'row',
  },
  input: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
    borderBottomEndRadius: 10,
    borderTopEndRadius: 10,
    borderBottomStartRadius: 10,
    borderTopStartRadius: 10,
    overflow: 'hidden',
    width: 200,
    textAlign: 'center',
    backgroundColor: 'white',
  },
  buttonWrapper: {
    borderRadius: 21,
    width: 300,
    height: 50,
    marginTop: 40,
    marginBottom: 10,
    alignSelf: 'center',
  },
  buttonText: {
    fontSize: 17,
    color: 'white',
    fontWeight: 'bold',
    alignSelf: 'center',
    textAlign: 'center',
  },
  invalidText: {
    fontWeight: '500',
    color: 'red',
    fontSize: 14,
    justifyContent: 'center',
    textAlign: 'center',
  },
});
